import { SpinnerGapIcon } from '@phosphor-icons/react'
import { useSyncExternalStore } from 'react'

import { type ColdStartState, getColdStartState, onColdStartChange } from '@/lib/api'

function subscribe(cb: () => void) {
	return onColdStartChange(cb)
}

function getSnapshot(): ColdStartState {
	return getColdStartState()
}

export function ColdStartBanner() {
	const state = useSyncExternalStore(subscribe, getSnapshot, () => 'unknown' as const)

	if (state !== 'waking') return null

	return (
		<div className="bg-muted/80 fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-2 px-4 py-2 text-sm backdrop-blur-sm">
			<SpinnerGapIcon weight="thin" className="size-4 animate-spin" />
			<span>Starting up server — this may take a minute or two...</span>
		</div>
	)
}
